/* eslint no-unused-vars: 'off' */

import React from 'react';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';

class CiAlphaSliderComponent extends React.PureComponent {

  calculateInputValue = inpValue => (inpValue > 0.99999 ? 0.99999 : inpValue) || (inpValue < 0.00001 ? 0.00001 : inpValue);

  render () {
    const { input, meta, ...props } = this.props;

    const { onChange: handleChange } = input;

    return (
      <Slider
        {...props}
        value={this.calculateInputValue(+input.value)}
        onChange={handleChange}
        className="main-slider"
      />
    );
  }
}

CiAlphaSliderComponent.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired
  }).isRequired,

  meta: PropTypes.any.isRequired
};

export default CiAlphaSliderComponent;
